module.exports = __webpack_public_path__ + "img/logo_biotopia_row_color.7e6d000d.png";